<template>
  <Fragment>
    <Switcher
      name="interval"
      v-model="selectedInterval"
      leftValue="month"
      leftText="Monthly"
      rightValue="year"
      rightText="Yearly"
      save-text="Save 16%"
      style="margin-bottom: 20px"
    />

    <div class="plans">
      <ProPlusPlan
        :interval="selectedInterval"
        :price="selectedInterval === 'month' ? '24' : '240'"
      >
        <template slot="actions">
          <Button
            href="https://app.campsite.bio/create-account?pro_plus=true"
            size="large"
            >Start Your Free Trial</Button
          >
        </template>
        <template slot="below-actions">
          10-day trial included •
          <InlineLink to="/demo">Request a demo</InlineLink>
        </template>
      </ProPlusPlan>
      <ProPlan
        :interval="selectedInterval"
        :price="selectedInterval === 'month' ? '7' : '70'"
      >
        <template slot="actions">
          <Button
            href="https://app.campsite.bio/create-account?pro=true"
            size="large"
            >Start Your Free Trial</Button
          >
        </template>
        <template slot="below-actions"> 10-day trial included </template>
      </ProPlan>
      <FreePlan>
        <template slot="actions">
          <Button
            href="https://app.campsite.bio/create-account"
            variant="outline"
            size="large"
            >Get Started Free</Button
          >
        </template>
      </FreePlan>
    </div>
  </Fragment>
</template>

<script>
import Switcher from '@/components/switcher';
import { Button, InlineLink } from '@campsite-bio/component-lib';

import FreePlan from './free-plan';
import ProPlan from './pro-plan';
import ProPlusPlan from './pro-plus-plan';

export default {
  data() {
    return {
      selectedInterval: 'month',
    };
  },

  components: {
    Switcher,
    Button,
    FreePlan,
    ProPlan,
    ProPlusPlan,
    InlineLink,
  },
};
</script>

<style lang="scss" scoped>
.plans {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin: 1.5rem 0;
  text-align: left;
}
</style>
